import { LOCALES, useLocale } from '@/lib/i18n';
import { cn } from '@/lib/utils';

export function LocaleToggle() {
  const { locale, setLocale } = useLocale();
  return (
    <div className="flex items-center rounded-md border border-border p-0.5">
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLocale(l)}
          className={cn(
            'rounded px-2.5 py-2 text-label uppercase transition-fast sm:px-2 sm:py-1',
            l === locale ? 'bg-surface-3 text-fg' : 'text-fg-subtle hover:text-fg',
          )}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
